import { get } from "lodash";
import { getTypeForGroup } from "src/util/customerConfig";
import {
  canEditPlanning,
  shouldShowPlanningSurfacesWhenOutsideGroupAccess,
} from "./planningAccess";

const getAllocationVisibility = ({
  group = {},
  config,
  activeAllocationProject,
  userRole,
}) => {
  const { isDeleted } = group;
  const isAllocationsClosed = !activeAllocationProject;
  const isOutsideHierarchy = !get(
    group,
    "permissions.areGroupsInAccessGroupIdsHierarchy"
  );
  const allocationConfig = config?.allocation;
  const showReadOnlyPlanning =
    isOutsideHierarchy &&
    shouldShowPlanningSurfacesWhenOutsideGroupAccess({
      allocationConfig,
      group,
      userRole,
    });
  const isDeniedAccess = isOutsideHierarchy && !showReadOnlyPlanning;
  const planningEditable = canEditPlanning({
    allocationConfig,
    group,
    userRole,
  });

  if (isAllocationsClosed || isDeniedAccess || isDeleted) {
    return {
      requestNumbers2: false,
      requestPeople: false,
      approveNumbers2: false,
      individualAllocations: false,
      forecastNumbers: false,
      isAllocationsClosed,
      isDeniedAccess,
      isDeleted,
      canEditPlanning: false,
    };
  }
  const groupTypeConfig = getTypeForGroup(config.groupTypes, group);
  const { disableGroupPlanner, disableGroupForecast, disableGroupTeamBuilder } =
    config.allocation;

  const isRequestorType = groupTypeConfig?.isDemandRequestor ?? false;
  const isDemandRollupTargetType = Boolean(
    config.featureFlags?.enableDemandRollupPlanning &&
    groupTypeConfig?.isDemand &&
    groupTypeConfig?.planning?.isDemandRollupTarget
  );
  const isLineOfBusinessType = groupTypeConfig?.isLineOfBusiness ?? false;
  const isApproverType = groupTypeConfig?.isSupplyApprover ?? false;
  const isPlanningRequestorType = isRequestorType || isDemandRollupTargetType;

  return {
    requestNumbers2:
      !disableGroupPlanner && (isPlanningRequestorType || isLineOfBusinessType),
    requestPeople: !disableGroupTeamBuilder && isRequestorType,
    approveNumbers2: !disableGroupPlanner && isApproverType,
    individualAllocations: !disableGroupTeamBuilder && isApproverType,
    forecastNumbers:
      !disableGroupForecast && (isPlanningRequestorType || isApproverType),
    isAllocationsClosed,
    isDeniedAccess,
    canEditPlanning: planningEditable,
  };
};

export default getAllocationVisibility;
